import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'moi-event-summary',
    templateUrl: './moi-event-summary.component.html',
    styleUrls: ['./moi-event-summary.component.scss'],
    standalone: false,
    providers: [provideTranslocoScope('moi')],
})
export class MoiEventSummaryComponent {
  private tabservice = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() eventID: any;

  openEvent() {
      if (!this.eventID || !this.summaryModel.CanOpenParent) {
          return;
      }

      this.tabservice.generateTab(this.pages.EventDetail, this.eventID);
  }
}
